import { DEFAULT_LOCATIONS, DROPDOWN_AUTOCOMPLETE, WALMART } from 'utils/constants';
import { selectToken, getEnv, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token 878f51af12d0432d04d00b538c0289d13a8c33a1',
  staging: 'Token 1dede7e7d6641a20bf5c8176614a500548b17752',
  prod: 'Token cdfb7df55a175e0b6c56064012d3c6c8dac52c2f',
};

const token = selectToken(apiTokens);

const walmartConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: getEnv() === 'production' ? 'wpg' : 'walmart',

  API_TOKEN: token,
  EMBOLD_CLIENT: WALMART,
  SHOW_REGION_SELECTOR: true,
  HIGH_QUALITY_INTRO_MODAL: true,
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Bentonville },
  LOGIN_NETWORK_NAME: 'wmtLoggedIn',

  // content
  DISPLAY_NAME: 'Walmart',
  NO_WELCOME_LINK: true,
  FORM_VARIANT: DROPDOWN_AUTOCOMPLETE,
};

export default walmartConfig;
